import openTab from './open-tab';

const DEFAULT_POPUP_PARAMS = {
  toolbar: false,
  location: false,
  directories: false,
  status: false,
  menubar: false,
  scrollbars: true,
  resizable: true,
  copyhistory: false,
};

export default function openPopup(url, width = 980, height = 600) {
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;

  const params = { ...DEFAULT_POPUP_PARAMS, width, height, top, left };

  openTab(url, params);
}



// WEBPACK FOOTER //
// ./src/shared/utils/open-popup.js